var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{staticStyle:{"width":"100%","padding-top":"15px"},attrs:{"data":_vm.childMsg.listData}},_vm._l((_vm.childMsg.data),function(item){return _c('el-table-column',{attrs:{"prop":item.prop,"label":item.label,"min-width":"120"}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496ab507","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/admin/components/TransactionTable.vue
// module id = null
// module chunks = 